import React from "react";
import "../css/dashboard.css";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import TutorialVideosContentMobile from "../component/Misc/TutorialVideosContentMobile";

export default function TutorialsContentMobile() {

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics(
  //       "Tutorials",
  //       "pageLoadMobile",
  //       currentUser.email,
  //       "read",
  //       "bodhi"
  //     );
  //   }
  // }, [currentUser.email]);

  return (
    <div className="right-container-mobile">
      <TopTitleBannerMobile title={"Tutorials"} />
      <TutorialVideosContentMobile />
    </div>
  );
}
